import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-einvoice-tin-input',
  templateUrl: './einvoice-tin-input.component.html',
  styles: [
    `
      input {
        width: 115px !important;
      }
    `
  ],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EInvoiceTINInputComponent),
      multi: true
    }
  ]
})
export class EInvoiceTINInputComponent implements ControlValueAccessor {
  @Input() value: any;
  @Input() disabled = false;
  @Input() maxChar: number = 99;

  @Input() allowDash: boolean = false;
  @Input() allowDot: boolean = false;
  @Input() allowSemiColon: boolean = false;

  @Input() isRequired: boolean = false;
  @Input() isEnabled: boolean = true;
  @Input() placeHolder: string = '';
  @Input() borderless = false;
  @Input() ignoreZero = false;
  @Input() allowEdit = true;

  get readonly() {
    if (this.disabled || !this.allowEdit) {
      return true;
    }
    return false;
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  get format() {
    return `^[A-Z0-9${this.allowDash ? '-' : ''}${this.allowDot ? '.' : ''}${this.allowSemiColon ? ';' : ''}]+$`;
  }

  constructor(private cdr: ChangeDetectorRef) {}

  writeValue(value: number): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onModelChange(val: any) {
    if (val)
      this.value = formatEInvoiceTIN(
        this.maxChar,
        this.allowDash,
        this.allowDot,
        this.allowSemiColon,
        val
      );
    else this.value = '';
    this.onChange(val);
    this.cdr.markForCheck();
  }

  onKeyUp(event: any) {
    const input = formatEInvoiceTIN(
      this.maxChar,
      this.allowDash,
      this.allowDot,
      this.allowSemiColon,
      event.target.value
    );

    event.target.value = input;
    return false;
  }

  onPaste(event: ClipboardEvent) {
    var clipData = event.clipboardData?.getData('text').toUpperCase();

    if (clipData) {
      const formatRegexString = this.format.replace(
        /[.*+?^${}()|[\]\\]/g,
        '\\$&'
      );
      const alphaRegex = new RegExp(formatRegexString);
      var isInvalid = alphaRegex.test(clipData);

      if (isInvalid) event.preventDefault();
    } else {
      event.preventDefault();
    }
  }

  onKeydown(event: any) {
    if (event.ctrlKey || event.metaKey) return;

    const key = `${event.key}`.toUpperCase();
    if (key.length !== 1) return;
    const allow =
      (key >= '0' && key <= '9') ||
      (key >= 'A' && key <= 'Z') ||
      (key === '-' && this.allowDash === true) ||
      (key === '.' && this.allowDot === true) ||
      (key === ';' && this.allowSemiColon === true);
    if (!allow) {
      event.preventDefault();
    }
  }

  onClick(e: any) {
    if (!window.getSelection()?.toString()) {
      e.select();
    }
  }
}

export function formatEInvoiceTIN(
  maxChar: number,
  allowDash: boolean,
  allowDot: boolean,
  allowSemiColon: boolean,
  input: string
) {
  let result = '';

  let digitCount = 0;
  for (let c of input.toUpperCase()) {
    if (
      (c >= '0' && c <= '9') ||
      (c >= 'A' && c <= 'Z') ||
      (c === '-' && allowDash === true) ||
      (c === '.' && allowDot === true) ||
      (c === ';' && allowSemiColon === true)
    ) {
      digitCount++;
      result += c;
      if (maxChar && digitCount === maxChar) return result;
    }
  }
  return result;
}
